import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useAppContext } from "../../context/state";
import { storage, useRequest } from "../../utils";
//locall
import "./SignIn.css";

const SignIn = (props) => {
  let { setToken } = useAppContext();

  const [user_name, set_user_name] = useState("");
  const [password, set_password] = useState("");
  const [
    login_user_error,
    login_user_loading,
    login_user_data,
    login_user_function,
  ] = useRequest({
    isFunction: true,
    method: "post",
    url: "/login_user",
    token: false,
    body: {
      user_name,
      password,
    },
  });

  let history = useHistory();
  return (
    <div
      class="SignInContainer vertical-layout vertical-menu-modern 1-column  navbar-sticky footer-static bg-full-screen-image  blank-page blank-page"
      data-open="click"
      data-menu="vertical-menu-modern"
      data-col="1-column"
    >
      {/* <!-- BEGIN: Content--> */}
      <div class="app-content content SignInContent">
        <div class="content-overlay"></div>
        <div class="content-wrapper">
          <div class="content-header row"></div>
          <div class="content-body">
            {/* <!-- login page start --> */}
            <section
              id="auth-login"
              class="row flexbox-container SignInSectionContainer"
            >
              <div class="SignInSection">
                <div class="card bg-authentication mb-0">
                  <div class="row m-0">
                    {/* <!-- left section-login --> */}
                    <div class="col-md-6 col-12 px-0">
                      <div class="card disable-rounded-right mb-0 p-2 h-100 d-flex justify-content-center">
                        <div class="card-header pb-1">
                          <div class="card-title">
                            <h4 class="text-center mb-2">خوش آمدید</h4>
                          </div>
                        </div>
                        <div class="card-content">
                          <div class="card-body">
                            {/* <div class="d-flex flex-md-row flex-column justify-content-around">
                              <a
                                href="#"
                                class="btn btn-social btn-google btn-block font-small-3 mr-md-1 mb-md-0 mb-1"
                              >
                                <i class="bx bxl-google font-medium-3"></i>
                                <span class="pl-50 d-block text-center">
                                  گوگل
                                </span>
                              </a>
                              <a
                                href="#"
                                class="btn btn-social btn-block mt-0 btn-facebook font-small-3"
                              >
                                <i class="bx bxl-facebook-square font-medium-3"></i>
                                <span class="pl-50 d-block text-center">
                                  فیسبوک
                                </span>
                              </a>
                            </div> */}
                            {/* <div class="divider">
                              <div class="divider-text text-uppercase text-muted">
                                <small>خوش آمدید</small>
                              </div>
                            </div> */}
                            <div>
                              {login_user_error ? (
                                <div style={{ color: "red" }}>
                                  مشکلی پیش امده است.
                                </div>
                              ) : null}
                              <div class="form-group mb-50">
                                <label
                                  class="text-bold-700"
                                  for="exampleInputEmail1"
                                >
                                  نام کاربری
                                </label>
                                <input
                                  type="text"
                                  class="form-control text-left"
                                  id="exampleInputEmail1"
                                  placeholder="نام کاربری"
                                  dir="ltr"
                                  onChange={(e) =>
                                    set_user_name(e.target.value)
                                  }
                                />
                              </div>
                              <div class="form-group">
                                <label
                                  class="text-bold-700"
                                  for="exampleInputPassword1"
                                >
                                  رمز عبور
                                </label>
                                <input
                                  type="password"
                                  class="form-control text-left"
                                  id="exampleInputPassword1"
                                  placeholder="رمز عبور"
                                  dir="ltr"
                                  onChange={(e) => set_password(e.target.value)}
                                />
                              </div>
                              <div class="form-group d-flex flex-md-row flex-column justify-content-between align-items-center">
                                <div class="text-left">
                                  <div class="checkbox checkbox-sm">
                                    <input
                                      type="checkbox"
                                      class="form-check-input"
                                      id="exampleCheck1"
                                    />
                                    <label
                                      class="checkboxsmall"
                                      for="exampleCheck1"
                                    >
                                      <small>مرا به خاطر بسپار</small>
                                    </label>
                                  </div>
                                </div>
                                <div class="text-right line-height-2">
                                  <a
                                    href="auth-forgot-password.html"
                                    class="card-link"
                                  >
                                    <small>
                                      رمز عبورتان را فراموش کرده اید؟
                                    </small>
                                  </a>
                                </div>
                              </div>
                              <button
                                type="submit"
                                class="btn btn-primary glow w-100 position-relative"
                                onClick={() =>
                                  login_user_function().then(
                                    async (login_user_res) => {
                                      if (!login_user_res)
                                        return Promise.reject();
                                     await storage.save(
                                        "token",
                                        login_user_res.token
                                      );
                                      // set_user(data.data.user);

                                      setToken(login_user_res.token);
                                      history.replace("/dashboard");
                                    }
                                  )
                                }
                              >
                                ورود
                                <i
                                  id="icon-arrow"
                                  class="bx bx-left-arrow-alt"
                                ></i>
                              </button>
                            </div>
                            {/* <hr /> */}
                            {/* <div class="text-center">
                              <small class="mr-25">حسابی ندارید؟</small>
                              <a href="auth-register.html">
                                <small>ثبت نام</small>
                              </a>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!-- right section image --> */}
                    <div class="col-md-6 d-md-block d-none text-center align-self-center p-3">
                      <div class="card-content">
                        <img
                          class="img-fluid"
                          src="../../assets/images/pages/login.png"
                          alt="branding logo"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* <!-- login page ends --> */}
          </div>
        </div>
      </div>
      {/* <!-- END: Content--> */}
    </div>
  );
};

export { SignIn };
